import React from 'react'
import { useTranslation } from 'react-i18next'
// import Sort from "../../../../../components/sort/sort";
// import Search from "../../../../../components/search/search";
import { useSelector } from 'react-redux';
import { useUnpaidCreditsStore, useUnpayedTransactions } from '../../hooks';
import { UnpaidRow } from './components/UnpaidRow';

export const List = () => {

    const { isLoading, data, isError } = useUnpayedTransactions()

    const { t } = useTranslation();

    const lng = useSelector((state) => (state as any).common.lng)

    const { dispatch, selectedItems } = useUnpaidCreditsStore()

    // const handleSort = (e) => {
    //     // setData([])
    //     // setTimeout(() => {
    //     //   setData(e)
    //     // } ,0)
    // }

    // const handleSearch = (e) => {

    //     // clearTimeout(searchTime)


    //     // let loop = setTimeout(() => {

    //     //   handleList(1 , perPage , e);

    //     // }, 1000)
    //     // setSearchTime(loop)

    // }



    const handleToggleAll = (state: boolean) => {

        if (state) dispatch({
            selectedItems: data?.details.data.data
                .map(item => ({
                    credit: item, crews: item.transaction.item?.crews
                        .filter(i => !!i?.crew)
                        ?.map(i => i.crew_id) ?? []
                }))
                .filter(i => i?.crews?.length > 0) //Only Visas That Contain Existing Crews
                .map(i => ({ credit: i.credit, crews: i.crews.filter(c => (JSON.parse(i.credit.paid_crews ?? '[]') as unknown as Array<string>).findIndex(i => i == c) == -1) })) //Only Unpaid Visas
                ?? []
        })

        else dispatch({ selectedItems: [] })
    }


    if (isLoading)
        return <div className='flex flex-col gap-4'>
            {Array.from(new Array(10)).map(item => <div className='bg-gray-100 rounded-lg w-full h-16 animate-pulse'></div>)}
        </div>

    else if (data) {

        const list = data?.details?.data?.data

        return (

            <table className="w-full text-sm text-gray-500 border border-gray-100 rounded-lg overflow-hidden box-border">
                <thead className="text-xs text-gray-700 uppercase ">
                    <tr className={"border-b border-gray-400 "} >

                        <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                            <label className={"mt-1"} title={t('All')}>
                                <input
                                    type='checkbox'
                                    className='rounded'
                                    checked={selectedItems.length == data.details.data.data.filter(i => i.transaction.item?.crews.findIndex(i => !i?.crew) == -1).length}
                                    onChange={({ target: { checked } }) => handleToggleAll(checked)}
                                />
                            </label>
                        </th>

                        <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                            <div className={"mt-1"}>
                                #
                                {/* {t("row")} */}
                            </div>
                        </th>


                        {/* <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                            <div className={"mt-1 justify-center flex"}>
                               <Sort data={list} childKey={"visa"} sortKey={`${lng}_name`} onSort={(e) => handleSort(e)} /> 
                                {t("visaType")}
                            </div>
                        </th>*/}
                        <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                            <div className={"mt-1 flex  justify-center"}>
                                {/* <Sort data={list} sortKey={"created_at"} parentKey={"visa"} onSort={(e) => handleSort(e)} /> */}
                                {t("requestDate")}
                            </div>
                        </th>
                        <th scope="col" className=" py-3 mx-auto text-center font-normal text-gray-600 text-sm">
                            <div className={"mt-1 flex justify-center"}>
                                {/* <Sort data={list} sortKey={"status"} parentKey={"visa"} onSort={(e) => handleSort(e)} /> */}
                                {t("visaType")}
                            </div>
                        </th>
                        {/*  {true &&  <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                            <div className={"mt-1 flex  justify-center"}>
                                <Sort data={list} sortKey={"expired_at"} parentKey={"visa"} onSort={(e) => handleSort(e)} /> 
                                {t("agent")}
                            </div>
                        </th>}*/}
                        <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                            <div className={"mt-1 flex  justify-center"}>
                                {/* <Sort data={list} sortKey={"expired_at"} parentKey={"visa"} onSort={(e) => handleSort(e)} /> */}
                                {t("crew")}
                            </div>
                        </th>


                        <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm" align='center'>
                            <div className={"mt-1 flex text-center justify-center"}>
                                {/* <Sort data={list} sortKey={"name"} parentKey={"crew"} onSort={(e) => handleSort(e)} /> */}
                                {/* {t("crewName")} */}
                                {t("VisaPrice")}
                            </div>
                        </th>

                        <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm" align='center'>
                            <div className={"mt-1 flex text-center justify-center"}>
                                {/* <Sort data={list} sortKey={"name"} parentKey={"crew"} onSort={(e) => handleSort(e)} /> */}
                                {/* {t("crewName")} */}
                                {t("DebtAmount")}
                            </div>
                        </th>

                        <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm" align='center'>
                            <div className={"mt-1 flex text-center justify-center"}>
                                {/* <Sort data={list} sortKey={"name"} parentKey={"crew"} onSort={(e) => handleSort(e)} /> */}
                                {/* {t("crewName")} */}
                                {t("status")}
                            </div>
                        </th>
                        {/* <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                            <div className={"mt-1 flex  justify-center"}>
                                <Sort data={list} sortKey={"expired_at"} parentKey={"visa"} onSort={(e) => handleSort(e)} />
                                {t("automationNumber")}
                            </div>
                        </th>
                       <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                             <Search onChange={handleSearch} /> 
                        </th>*/}
                    </tr>
                </thead>

                <tbody>

                </tbody>

                {list?.map((item, index) => <UnpaidRow {...item} />)}

            </table>
        )
    }

    else if (isError)
        return <span className='text-red-500'> Something Went Wrong</span>
    else return <></>
}
